import { screenSelectionTypeMap } from '@src/containers/QuizContainer/answerMapping';
import { GetRecommendationsQuery } from '@src/graphqlTypes/catalogServiceTypes';
import { SortedRecommendationQuizResponses } from './RecommendationsProvider';

export const toQuizAnswers = (responses: GetRecommendationsQuery['quizResponses']) => {
	return responses.reduce((allAnswers, currentResponse) => {
		const screenName = currentResponse?.screenName
			?.toLowerCase()
			?.replace(/(_\w)/g, k => k[1].toUpperCase());
		const screenSelectionType = screenSelectionTypeMap[screenName];

		if (screenSelectionType) {
			allAnswers[screenName] = currentResponse.response[screenSelectionType];
		}

		if (screenName === 'interests') {
			const interests = currentResponse.response[screenSelectionType];
			allAnswers.interests = interests.filter(
				(i: string) => !i.includes('>') && !i.includes('All') && !i.includes('<')
			);

			allAnswers.businessInterests = interests
				.filter(
					(i: string) =>
						i.includes('Business <') || i.includes('Business >') || i.includes('All business')
				)
				.map((i: string) => i.replace('<', '>'));

			allAnswers.healthcareInterests = interests
				.filter(
					(i: string) =>
						i.includes('Healthcare <') || i.includes('Healthcare >') || i.includes('All healthcare')
				)
				.map((i: string) => i.replace('<', '>'));

			allAnswers.techInterests = interests
				.filter(
					(i: string) =>
						i.includes('Technology <') || i.includes('Technology >') || i.includes('All technology')
				)
				.map((i: string) => i.replace('<', '>'));
		}

		return allAnswers;
	}, {} as SortedRecommendationQuizResponses);
};
